WiseMetering.Views.ManageGroup = WiseMetering.Views.Modal.Save.extend({
    template: 'templates/groups/manage',
    className: 'mbx-info text-left',
    form_prefix: 'group',
    input_readers: [{ type: 'checkbox', func: function(el) {
        if (el.prop('checked')) {
            return el.val();
        }
    } }],

    events: {
        'click #all_sites': 'toggleSites',
        'click #all_users': 'toggleUsers'
    },

    title: function() {
        return i18next.t(`modal.title.groups.${this.model.isNew() ? 'new' : 'edit'}`);
    },

    ui: {
        allSites: '#all_sites',
        allUsers: '#all_users',
        sites: '#sites',
        users: '#users'
    },

    serializeData: function() {
        const json = {};
        json.isNew = this.model.isNew();
        json.name = this.model.get('name');
        json.description = this.model.get('description');
        json.allUsers = WiseMetering.users.assignable();
        json.myUsers = this.model.users();
        json.allSites = WiseMetering.zones.sites();
        json.mySites = this.model.sites();
        return json;
    },

    toggleSites: function() {
        const selected = this.ui.allSites.prop('checked');
        _.each(this.ui.sites.children('input'), function(input) {
            $(input).prop('checked', selected);
        });
    },

    toggleUsers: function() {
        const selected = this.ui.allUsers.prop('checked');

        _.each(this.ui.users.children('input'), function(input) {
            $(input).prop('checked', selected);
        });
    }
});
